<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'平台宣传管理'},{name:'平台宣传列表',goback:true},{name:'添加平台宣传'}]" :title="'添加平台宣传'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>视频名称：</div>
                        <div class="content">
                          <el-input v-model="sendInfo.title" maxlength="20"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.title']">错误提示：{{errors['sendInfo.title']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>附件</span>：</div>
                        <div class="content" >
                          <upLoadFiles
                          v-model="sendInfo.videoUrl"
                          :action="'backstage/annex/files'"
                          :size="20"
                          tip="附件总计不超过50M"
                          :accept="'video/*'"
                          />
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.videoUrl']">错误提示：{{errors['sendInfo.videoUrl']}}</div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="singleBtn" style="text-align:left">
                              <el-button type="primary" size="small" @click="submit">发布</el-button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadVideo'
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoadFiles
    },
    data(){
        return{
            statusList: [],//服务类型
			id:'',
            sendInfo:{
                id: void 0,
                pageView: void 0,
                putawayStatus: void 0,
                title: void 0,
                videoUrl: void 0
            },
			dict:{
				currentPage:1,
				direction:null,
				pageSize:10,
				parentId :1069409909080064,
				property:null,
			}
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
            'sendInfo.title': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择填写视频标题'
            },
            'sendInfo.videoUrl': {
                test: function (val) {
                    if (val.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '上传视频'
            },
            
        },
	created() {
		// /backstage/sysDict/parentId
		
		if(this.$route.query.id){
		    this.id=this.$route.query.id;
			this.sendInfo.intermediaryServiceId=this.$route.query.id;
			this.getDetail();
		}
		
	},
    methods:{
		getDetail(){
			this.$axiosc.get('backstage/intermediary/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
					let	sendInfo={
					    "intermediaryServiceId": r.data.id,//中介服务ID，编辑时必传
					    "logo": r.data.logo,
					    "name": r.data.name,//中介服务名称
					    "serviceType": r.data.serviceType,//服务类型
					    "summary": r.data.summary,//简介
					    "websiteLink": r.data.websiteLink,//网址链接
						contactPerson:r.data.contactPerson,//联系人
						contactNumber:r.data.contactNumber,//联系人电话
					}
					this.sendInfo=sendInfo;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
              const {id,title,videoUrl} = this.sendInfo
              const param = {
                id:id|| void 0,
                title,
                videoUrl:Array.isArray(videoUrl)?videoUrl[0].filePath: videoUrl
              }
              this.$axioscBody.post('/backstage/publicity/savePublicity',param).then((r)=>{
                if(r.code==200){
                  this.$message({
                    type: 'success',
                    message: r.msg
                  });
                  this.$router.back();
                }else{
                  this.$alert(r.msg);
                }
              })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 50px;
        // border-top:1px solid rgba(112, 112, 112, 0.1);
        .forms{
            max-width: 650px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>